// ============================================================
// posicion.js — dónde va una pieza DENTRO de su contenedor, en porcentajes.
//
// Módulo PURO (sin DOM, sin estado, ES2019 → node-testeable), a propósito en `utils/` y no en
// `editor/`: lo consumen las DOS orillas —el RENDER de un bloque, que pinta la posición, y el
// ARRASTRE del editor, que la calcula— y un bloque no puede importar de `js/editor/` sin
// arriesgar el ciclo registry→bloque (gotcha nº3).
//
// UN SOLO DATO PARA LOS DOS MODOS: la posición es siempre `{x, y}` en % del contenedor. El
// arrastre libre escribe cualquier valor; el imán de MAYÚS escribe uno de los nueve de la
// rejilla. Si algún día se retira el modo libre, un selector 3×3 escribe esos mismos nueve
// valores y no hay que migrar ni un sitio guardado.
// ============================================================

/** Rejilla de imán: 3 columnas × 3 filas, en % del contenedor. */
export var ANCLAS_X = [8, 50, 92];
export var ANCLAS_Y = [10, 50, 90];

/** Posición por defecto de una pieza recién colocada: abajo y centrada. */
export var POS_DEFECTO = { x: 50, y: 88 };

function _num(v, porDefecto) {
    var n = Number(v);
    return isFinite(n) ? n : porDefecto;
}

/** Normaliza lo que venga en props a un `{x, y}` usable. Nunca lanza. */
export function posSegura(pos) {
    if (!pos || typeof pos !== 'object') return { x: POS_DEFECTO.x, y: POS_DEFECTO.y };
    return {
        x: Math.max(0, Math.min(100, _num(pos.x, POS_DEFECTO.x))),
        y: Math.max(0, Math.min(100, _num(pos.y, POS_DEFECTO.y)))
    };
}

function _cerca(v, opciones) {
    return opciones.reduce(function (mejor, o) {
        return Math.abs(o - v) < Math.abs(mejor - v) ? o : mejor;
    }, opciones[0]);
}

/** Ancla de la rejilla más cercana a un punto (lo que hace el imán de MAYÚS). */
export function imanARejilla(x, y) {
    return { x: _cerca(x, ANCLAS_X), y: _cerca(y, ANCLAS_Y) };
}
